<template>

  <component :is="el" :label="label" :align="align" :prop="prop" :required="required">

    <span v-if="noForm && showLabel">{{label}}</span>

    <el-date-picker
      v-if="!disabled"
      :ref="ref"
      v-model="formData"
      :type="localType"
      :format="dateFormat"
      :value-format="valueFormat"
      :disabled="disabled"
      :placeholder="placeholder"
      :picker-options="dateOptions"
      :required="required"
      @change="updated">
    </el-date-picker>
    <b v-else>{{this.formatDate(formData)}}</b>
  </component>

</template>

<script>

import {settings} from '@/components/Data'
import {pickerValueFormat} from '@/lib/appTime'

import DateMixins from '@/mixins/DateMixins'

export default {
  name: 'date-input',

  mixins: [DateMixins],

  props: {
    label: {
      type: String,
      default: null
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'top'
    },
    value: {
//      type: Date,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'date'
    },
    format: {
      type: String,
      default: 'dd MMM yyyy'
    },
    options: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    prop: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dateFormat: function () {
      return this.format ? this.format : settings.selectDateFormat
    },

    // XOL-414: emit a wire-shaped string, not a JS Date. `format` above is the
    // display mask; this is the v-model shape.
    valueFormat: function () {
      return pickerValueFormat(this.localType)
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  watch: {
    value: function (val) {
      this.formData = val
    }
  },


  data () {
    return {
      ref: 'date-' + Date.now() + '-' + Math.random(),
      localType: this.type ? this.type : 'date',
      formData: this.value,
      dateOptions: this.options,
      el: this.noForm ? 'div' : 'el-form-item'
    }
  }
}
</script>
